'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$0024anon$0024158 from "./presto.types$$anon$158.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dSeed$002dPayload$0024 from "./presto.types$-Two-Factor-Auth-Seed-Payload$.js";
var $p;
/** @constructor */
function $c_Lpresto_types$TwoFactorAuthPayload$$anon$157() {
  this.cdD = null;
  this.cdv = null;
  this.cdw = false;
  this.cdE = null;
  this.cdF = false;
  this.cdI = null;
  this.cdB = null;
  this.cdC = false;
  this.cdx = null;
  this.cdy = false;
  this.cdz = null;
  this.cdA = false;
  this.cdG = false;
  this.cdH = false;
  this.cdD = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.cdI = "TwoFactorAuthSeedPayload";
}
export { $c_Lpresto_types$TwoFactorAuthPayload$$anon$157 as $c_Lpresto_types$TwoFactorAuthPayload$$anon$157 };
$p = $c_Lpresto_types$TwoFactorAuthPayload$$anon$157.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$TwoFactorAuthPayload$$anon$157;
/** @constructor */
function $h_Lpresto_types$TwoFactorAuthPayload$$anon$157() {
}
export { $h_Lpresto_types$TwoFactorAuthPayload$$anon$157 as $h_Lpresto_types$TwoFactorAuthPayload$$anon$157 };
$h_Lpresto_types$TwoFactorAuthPayload$$anon$157.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.cdD;
});
$p.M = (function() {
  if ((!this.cdw)) {
    this.cdv = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.cdw = true;
  }
  return this.cdv;
});
$p.O = (function() {
  if ((!this.cdF)) {
    this.cdE = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.cdF = true;
  }
  return this.cdE;
});
$p.D = (function() {
  return this.cdI;
});
$p.t = (function() {
  if ((!this.cdC)) {
    this.cdB = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("secret", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.cdC = true;
  }
  return this.cdB;
});
$p.N = (function() {
  if ((!this.cdy)) {
    this.cdx = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.cdy = true;
  }
  return this.cdx;
});
$p.Q = (function() {
  if ((!this.cdA)) {
    this.cdz = new $j_presto$002etypes$0024$0024anon$0024158.$c_Lpresto_types$$anon$158();
    this.cdA = true;
  }
  return this.cdz;
});
$p.v = (function() {
  if ((!this.cdH)) {
    this.cdG = false;
    this.cdH = true;
  }
  return this.cdG;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee175) => ((p) => \u03b4scrutinee175.cHE(p)))($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dSeed$002dPayload$0024.$m_Lpresto_types$TwoFactorAuthSeedPayload$())));
});
var $d_Lpresto_types$TwoFactorAuthPayload$$anon$157 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$TwoFactorAuthPayload$$anon$157, "presto.types$TwoFactorAuthPayload$$anon$157", ({
  a2w: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_types$TwoFactorAuthPayload$$anon$157 as $d_Lpresto_types$TwoFactorAuthPayload$$anon$157 };
//# sourceMappingURL=presto.types$-Two-Factor-Auth-Payload$$anon$157.js.map
